class FetchHelpers{
    constructor(){
        this.headerToken = document.querySelector('input[name=__RequestVerificationToken]')?.value || '';
    }

}

export default new FetchHelpers();